import { Preferences } from '@capacitor/preferences';

export const storage = {
    async get(key: string) {
    const { value } = await Preferences.get({ key });
    return value;
  },
  
  async set(key: string, value: string) {
    await Preferences.set({ key, value });
  },
  async clear() {
    await Preferences.clear();
  }
};